module.exports = __webpack_public_path__ + "static/img/materialsInfo11.295d00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo11.png
// module id = 3oDu
// module chunks = 2